<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content} | Stichting WeShare4Kids` : `Stichting WeShare4Kids`
    }}</template>
  </metainfo>
  <v-app>
    <HeaderNav v-if="!$route.path.includes('/admin')" />
    <v-navigation-drawer
      v-model="$store.state.drawer"
      v-if="this.$vuetify.display.smAndDown"
      app
      class="bg-background ws-drawer"
    >
      <v-list nav dense active-color="primary">
        <v-list-item
          :active="isActive('/')"
          :aria-current="isActive('/') ? 'page' : undefined"
          @click="$router.push('/')"
        >
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>

        <v-list-item
          :active="isActive('/overons')"
          :aria-current="isActive('/overons') ? 'page' : undefined"
          @click="$router.push('/overons')"
        >
          <v-list-item-title>Over ons</v-list-item-title>
        </v-list-item>

        <v-list-item
          :active="isActive('/organisatie')"
          :aria-current="isActive('/organisatie') ? 'page' : undefined"
          @click="$router.push('/organisatie')"
        >
          <v-list-item-title>Organisatie</v-list-item-title>
        </v-list-item>

        <v-list-item
          :active="isActive('/nieuws')"
          :aria-current="isActive('/nieuws') ? 'page' : undefined"
          @click="$router.push('/nieuws')"
        >
          <v-list-item-title>Nieuws</v-list-item-title>
        </v-list-item>

        <v-list-group value="veelgestelde-vragen">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              :active="isActive('/veelgestelde-vragen')"
            >
              <v-list-item-title>Veelgestelde vragen</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-for="item in faqLinks"
            :key="item.link"
            :active="$route.path === item.link"
            :aria-current="$route.path === item.link ? 'page' : undefined"
            @click="$router.push(item.link)"
          >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item
          :active="isActive('/contact')"
          :aria-current="isActive('/contact') ? 'page' : undefined"
          @click="$router.push('/contact')"
        >
          <v-list-item-title>Contact</v-list-item-title>
        </v-list-item>
        <v-list-item class="ws-drawer-cta" @click="$router.push('/steunons')">
          <v-list-item-title
            ><v-icon size="x-small" class="mr-1">mdi-arrow-right</v-icon>Steun
            ons
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view v-slot="{ Component, route }">
        <transition name="slide-fade" mode="out-in">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view>
    </v-main>
    <FooterMenu v-if="!$route.path.includes('/admin')" />
  </v-app>
</template>

<script>
import HeaderNav from "@/components/HeaderNav.vue";
import FooterMenu from "@/components/FooterMenu.vue";
import { faqLinks } from "@/data/faq";
// import { useMeta } from "vue-meta";

export default {
  // setup() {
  //   useMeta({
  //     title: "Home",
  //   });
  // },
  name: "App",
  components: {
    HeaderNav,
    FooterMenu,
  },
  mounted() {
    this.$store.dispatch("getNieuws");
  },
  methods: {
    isActive(path) {
      if (path === "/") return this.$route.path === "/";
      return this.$route.path.startsWith(path);
    },
  },
  data: () => ({
    drawer: true,
    faqLinks,
  }),
};
</script>

<style lang="scss">
/* ===== "Calm warmth" design system — global type & base ===== */
.v-application {
  font-family: "Nunito Sans", -apple-system, BlinkMacSystemFont, sans-serif !important;
  color: #2a2018;
  -webkit-font-smoothing: antialiased;
}

h1,
h2,
h3,
h4,
h5,
h6,
.font-heading {
  font-family: "Nunito", sans-serif !important;
  letter-spacing: -0.02em;
  color: #241b12;
}

h1 {
  font-weight: 900;
}

h2,
h3 {
  font-weight: 800;
}

::selection {
  background: #f7c9a8;
  color: #2a2018;
}

/* ===== Mobile drawer ===== */
.ws-drawer {
  .v-list-item-title {
    font-family: "Nunito", sans-serif;
    font-weight: 700;
    color: #5c4f44;
  }
  .ws-drawer-cta {
    margin-top: 6px;
    background: #ea6b26;
    border-radius: 12px;
    .v-list-item-title {
      color: #fff;
      font-weight: 800;
    }
  }
}

.slide-fade-enter-active {
  transition: opacity var(--ws-dur-base) var(--ws-ease-out),
    transform var(--ws-dur-base) var(--ws-ease-out);
}
.slide-fade-leave-active {
  transition: opacity 120ms var(--ws-ease-out),
    transform 120ms var(--ws-ease-out);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(6px);
  opacity: 0;
}

.section {
  max-width: 1200px;
  width: 90vw;
  padding-top: 10vh;
  padding-bottom: 10vh;
  margin: auto;
}
</style>
